import { useEffect, useState } from "react";
import { guestAPI, fmtINR, VIP_STYLE } from "./guestApi";
import { BarChart3 } from "lucide-react";

export default function GuestAnalytics() {
  const [d, setD] = useState(null);
  const [top, setTop] = useState([]);
  useEffect(() => {
    guestAPI.dashboard().then(setD);
    guestAPI.list({ limit: 500 }).then(list => {
      const sorted = list.slice().sort((a, b) => (b.stats?.revenue || 0) - (a.stats?.revenue || 0)).slice(0, 10);
      setTop(sorted);
    });
  }, []);
  const k = d?.kpis || {};
  const maxRev = Math.max(1, ...top.map(g => g.stats?.revenue || 0));
  return (
    <div className="space-y-4" data-testid="guest-analytics">
      <div className="grid grid-cols-4 gap-3">
        {[
          {l: "Total Guests", v: k.guests || 0},
          {l: "VIP", v: k.vip || 0},
          {l: "Repeat", v: k.repeat || 0},
          {l: "Corporate", v: k.corporate || 0},
          {l: "Lifetime Revenue", v: fmtINR(k.lifetime_revenue || 0)},
          {l: "In-House", v: k.staying || 0},
          {l: "Arrivals Today", v: k.arrivals || 0},
          {l: "Guest Satisfaction", v: `${k.satisfaction || 0} / 5`},
        ].map((c, i) => (
          <div key={i} className="bg-white border border-slate-200 rounded-xl p-4" data-testid={`guest-analytics-kpi-${i}`}>
            <div className="text-[10.5px] uppercase tracking-wider text-slate-400 font-medium">{c.l}</div>
            <div className="mt-1 font-display text-[22px] font-semibold text-hocp-navy tabular-nums">{c.v}</div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2">
          <BarChart3 className="w-4 h-4 text-hocp-navy"/>
          <div className="font-display text-[14px] font-semibold text-hocp-navy">Top 10 Guests by Lifetime Revenue</div>
        </div>
        {top.length === 0
          ? <div className="p-8 text-center text-[13px] text-slate-400">No guest activity yet.</div>
          : <div className="divide-y divide-slate-100">
              {top.map((g, i) => {
                const rev = g.stats?.revenue || 0;
                const pct = Math.max(4, (rev / maxRev) * 100);
                return (
                  <div key={g.id} className="px-4 py-3" data-testid={`guest-top-${i}`}>
                    <div className="flex items-center gap-3 text-[13px]">
                      <span className="w-5 text-slate-400 mono tabular-nums">{i+1}.</span>
                      <span className="font-medium text-hocp-navy truncate flex-1">
                        {g.first_name} {g.last_name || ""}
                      </span>
                      <span className={`px-2 py-0.5 rounded-md text-[10.5px] font-medium capitalize ${VIP_STYLE[g.vip_level] || VIP_STYLE.standard}`}>{g.vip_level}</span>
                      <span className="mono tabular-nums w-16 text-right">{g.stats?.stays || 0} stays</span>
                      <span className="mono tabular-nums w-28 text-right font-semibold">{fmtINR(rev)}</span>
                    </div>
                    <div className="mt-1.5 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                      <div className="h-full bg-hocp-gold" style={{ width: `${pct}%` }}/>
                    </div>
                  </div>
                );
              })}
            </div>}
      </div>
    </div>
  );
}
